import styled from "styled-components";
import { useEffect } from "react";

interface ToggleButtonGroupProps {
    campo: { nome: string };
    getFieldValue: (campoNome: string) => string;
    handleInputChange: (nome: string, valor: string) => void;
    hasError?: boolean;
    opcoes: { label: string; valor: string | number | boolean }[];
    corSelecionado?: string;
    corBorda?: string;
    corTexto?: string;
    onCampoDigitar?: (e: any) => void;
    defaultValue?: string | number | boolean;
}

const Container = styled.div`
    display: flex;
    border-radius: 25px;
    overflow: hidden;
    border: 1px solid #ccc;
    width: fit-content;
`;

const ToggleButton = styled.button.attrs({ type: 'button' })<{
    ativo: boolean;
    corSelecionado?: string;
    corBorda?: string;
    corTexto?: string;
}>`
    padding: 8px 18px;
    border: none;
    background-color: ${({ ativo, corSelecionado }) => (ativo ? corSelecionado || "#0044cc" : "transparent")};
    color: ${({ ativo, corTexto }) => (ativo ? "#fff" : corTexto || "#0044cc")};
    font-weight: ${({ ativo }) => (ativo ? "bold" : "normal")};
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border-right: 1px solid ${({ corBorda }) => corBorda || "#0044cc"};

    &:last-child {
        border-right: none;
    }

    &:focus {
        outline: none;
    }
`;

export function ToggleButtonGroup({
    campo,
    getFieldValue,
    handleInputChange,
    hasError,
    opcoes,
    corSelecionado,
    corBorda,
    corTexto,
    onCampoDigitar,
    defaultValue
}: ToggleButtonGroupProps) {
    const valorSelecionado = getFieldValue(campo.nome);

    useEffect(() => {
        if ((valorSelecionado === undefined || valorSelecionado === "") && defaultValue !== undefined) {
            const valor = String(defaultValue);
            handleInputChange(campo.nome, valor);
            onCampoDigitar?.({ value: valor });
        }
    }, [valorSelecionado, defaultValue, campo.nome, handleInputChange, onCampoDigitar]);

    return (
        <Container style={{ borderColor: hasError ? "#dc3545" : corBorda || "#0044cc" }}>
            {opcoes.map((opcao, idx) => (
                <ToggleButton
                    key={idx}
                    ativo={valorSelecionado === String(opcao.valor)}
                    onClick={() => {
                        const valor = String(opcao.valor);
                        handleInputChange(campo.nome, valor);
                        onCampoDigitar?.({ value: valor });
                    }}
                    corSelecionado={corSelecionado}
                    corBorda={corBorda}
                    corTexto={corTexto}
                >
                    {opcao.label}
                </ToggleButton>
            ))}
        </Container>
    );
}
